import { Sparkles } from "lucide-react";

export const StreamingBanner = ({ label }: { label: string }) => (
  <div className="flex items-center gap-2 rounded-md border border-primary/30 bg-primary/5 px-3 py-1.5 text-xs text-primary">
    <Sparkles className="h-3.5 w-3.5 animate-pulse" />
    <span>
      Excerptus AI writing into <strong>{label}</strong> — editor locked until the stream finishes.
    </span>
  </div>
);
